export interface AbstractThinkingRequest {
  initialQueryOrTopic: string;
  iterations?: number;
  maxTokensPerAgentTurn?: number;
}

export interface AgentTurn {
  agentName?: string;
  input?: string;
  output?: string;
  timestamp?: string;
}

export interface AbstractThinkingResponse {
  finalConclusion?: string;
  thinkingProcess?: AgentTurn[];
  sessionId?: string;
  totalIterations?: number;
  executionTime?: string;
}

// Local storage models
export interface AbstractThinkingSession {
  id: string;
  topic: string;
  iterations: number;
  finalConclusion?: string;
  thinkingProcess?: AgentTurn[];
  createdAt: Date;
}

export interface AbstractThinkingSessionStorage {
  sessions: AbstractThinkingSession[];
  lastUpdated: Date;
}

// Constants
export const THINKING_CATEGORIES = [
  'Philosophical',
  'Scientific',
  'Ethical',
  'Logical',
  'Creative',
  'Strategic',
  'Analytical',
  'Conceptual',
  'Systems Thinking',
  'Critical Thinking',
  'Abstract Reasoning',
  'Theoretical',
  'Metaphysical',
  'Epistemological'
];

export const ITERATION_PRESETS = [
  { label: 'Quick (3 iterations)', value: 3 },
  { label: 'Standard (5 iterations)', value: 5 },
  { label: 'Deep (7 iterations)', value: 7 },
  { label: 'Exhaustive (10 iterations)', value: 10 }
];